import { BaseAuditModel } from "./baseAuditModel";

export class Subscription  {
    name: string = ''
    description: string = '';
    numberOfProperties: number = 0;
    numberOfTenancies: number = 0;
}
